module.exports = __webpack_public_path__ + "img/selected5-min.07eb037e.png";